import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';
import tableDataQueryStringBuilder from 'services/Utilities/TableData';

const getPanelTypes = async () => {
  const response = await axios.get(HOST + '/api/dealer-portal/wall/panel-types');
  return response.data;
};

const getPanelHeaders = async () => {
  const response = await axios.get(HOST + '/api/dealer-portal/wall/panel-headers');
  return response.data;
};

export const usePrefetchPanelTypes = () => {
  const queryClient = useQueryClient();
  queryClient.prefetchQuery({
    queryKey: ['panel-types'],
    queryFn: getPanelTypes,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export const usePanelTypes = () => {
  const query = useQuery({
    queryKey: ['panel-types'],
    queryFn: getPanelTypes,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return query;
};

export const usePrefetchPanelHeaders = () => {
  const queryClient = useQueryClient();
  queryClient.prefetchQuery({
    queryKey: ['panel-headers'],
    queryFn: getPanelHeaders,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export const usePanelHeaders = () => {
  const query = useQuery({
    queryKey: ['panel-headers'],
    queryFn: getPanelHeaders,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return query;
};

export const useDefaultWalls = () => {
  const query = useQuery({
    queryKey: ['default-walls'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/wall/default');
      return response.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return query;
};

export const useSearchWalls = tableDataParam => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['search-walls', JSON.stringify(tableDataParam)],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/wall/search', {
        paramsSerializer: params => tableDataQueryStringBuilder(params),
        params: tableDataParam,
      });
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
  return query;
};

export const useAvailableDisplays = () => {
  return {
    data: [
      {
        id: '1',
        descriptionEn: 'Black Panel',
        descriptionFr: 'Panneaux Noir',
      },
      {
        id: '2',
        descriptionEn: 'Ski-Doo',
        descriptionFr: 'Ski-Doo',
      },
      {
        id: '3',
        descriptionEn: 'Sea-Doo',
        descriptionFr: 'Sea-Doo',
      },
      {
        id: '4',
        descriptionEn: 'Can-Am',
        descriptionFr: 'Can-Am',
      },
      {
        id: '5',
        descriptionEn: 'Lynx',
        descriptionFr: 'Lynx',
      },
      {
        id: '6',
        descriptionEn: 'XPS',
        descriptionFr: 'XPS',
      },
    ],
  };
};
